<template>
  <div>
    <Nav />
    <section class="section" id="Main" role="main">
      <div class="container">
        <h2 class="title is-2">About Teaching Texas Slavery</h2>
        <h3 class="title is-3">Project Leads</h3>
        <div class="columns">
          <div class="column is-narrow">
            <figure class="image">
              <img src="images/anthony_brown.jpg" class="headshot" alt="Portrait of Dr. Anthony L. Brown" />
            </figure>
          </div>
          <div clas="column">
            <h4 class="title is-4 person">Dr. Anthony L. Brown</h4>
            <p class="subtitle is-6">
              Professor of Curriculum & Instruction in Social Studies Education
              <br />Co-founder and Co-Director of the Center for Innovation in Race, Teaching, &amp; Curriculum
            </p>
          </div>
        </div>

        <div class="columns">
          <div class="column is-narrow">
            <figure class="image">
              <img
                src="images/keffrelyn_brown.jpg"
                class="headshot"
                alt="Portrait of Dr. Keffrelyn D. Brown"
              />
            </figure>
          </div>
          <div clas="column">
            <h4 class="title is-4 person">Dr. Keffrelyn D. Brown</h4>
            <p class="subtitle is-6">
              Professor of Cultural Studies in Education
              <br />Co-founder and Co-Director of the Center for Innovation in Race, Teaching, &amp; Curriculum
            </p>
          </div>
        </div>

        <div class="columns">
          <div class="column is-narrow">
            <figure class="image">
              <img src="images/daina_berry.jpg" class="headshot" alt="Portrait of Dr. Daina Ramey Berry" />
            </figure>
          </div>
          <div clas="column">
            <h4 class="title is-4 person">Dr. Daina Ramey Berry</h4>
            <p class="subtitle is-6">
              Research Consultant and Co-Founder of the Texas Domestic Slave Trade Project
              <br />Oliver H. Radkey Regents Professor of History and Associate Dean of Graduate Education Transformation
            </p>
          </div>
        </div>

        <hr />
        <h2 class="title is-2">Advisory Board</h2>
        <div class="content">
          <p>Margaret Koch, MFA, Director, Bob Bullock Texas State History Museum</p>
          <p>Don Carelton, Ph.D., Director, Dolph Briscoe Center for American History</p>
          <p>Rachel Winston, MSIS, Archivist, LLILAS Benson Center for Latin American History</p>
          <p>Brook Davis, B.A., Grant Specialist, UT Austin College of Liberal Arts</p>
          <p>Sherry Field, Ph.D., Associate Dean, UT Austin College of Education</p>
          <p>Cinthia Salinas, Ph.D., Chair and Professor, UT Austin College of Education</p>
          <p>LaGarrett King, Ph.D., Associate Professor, University of Missouri Columbia</p>
          <p>
            Kate Shuster, Ph.D., Educational Consultant,
            <i>Teaching Tolerance</i>
          </p>
          <p>Joyce King, Ph.D., Professor, Georgia State University</p>
        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import Nav from "./components/Nav.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "Records",
  components: {
    Nav,
    Footer
  }
};
</script>

<style scoped>
.person {
  margin-top: 20px;
}
.headshot {
  width: 200px;
  padding: 5px;
  background: #ccc;
}
</style>